/**
 * Created by Ning Jiang on 2023-11-30.
 */
import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {PointerStateColorSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PointerState} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/PointerState";
import {GuiUtils} from "@nolimitcity/slot-launcher/bin/gui/utils/GuiUtils";
import {SvgLoader} from "@nolimitcity/slot-launcher/bin/loader/SvgLoader";
import {GuiDefaultTextures} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaultTextures";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class IntroButton extends GuiButton {

    static BUTTON_LABEL_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fill : "#000000",
        fontFamily : OpenSans.FAMILY,
        fontSize : 34, //In mockup was 54
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.THIN,
        padding : 10
    });

    private BUTTON_LABEL_STYLE2:PIXI.TextStyle = new PIXI.TextStyle({
        fill : "#ffffff",
        fontFamily : OpenSans.FAMILY,
        fontSize : 34, //In mockup was 54
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.THIN,
        padding : 10
    });

    private _label:Label;
    private _backplate:PIXI.NineSlicePlane;
    private _stroke:PIXI.NineSlicePlane;
    private _colors:PointerStateColorSet;

    constructor(customText?:string) {
        super(customText ? customText : "continues" + "intro_button");
        customText = NolimitApplication.apiPlugin.translations.translate("SIGN HERE");
        this._label = new Label(customText, IntroButton.BUTTON_LABEL_STYLE);
        this._backplate = IntroButton.createBackPlate();
        this._stroke = IntroButton.createButtonStroke();

        this._colors = new PointerStateColorSet(
            0xff000000,
            undefined,
            undefined,
            0x80000000,
        );

        this.addChild(this._backplate);
        this.addChild(this._stroke);
        this.addChild(this._label);
        this.resizeButtonToLabelWithMargin(18, 30, 18, 30);
    }

    protected onPointerStateUpdate = (state:PointerState) => {
        const alpha = GuiUtils.getAlphaFromARGB(this._colors.getItem(state));
        this.alpha = alpha;
    };

    public setSize(width:number, height:number) {
        this._backplate.width = width;
        this._backplate.height = height;
        this._stroke.width = width;
        this._stroke.height = height;
        this._label.anchor.set(0.5, 0.5);
        this._label.position.set(width * 0.5, height * 0.5);
    }

    public resizeButtonToLabelWithMargin(top:number = 0, right:number = 0, bottom:number = 0, left:number = 0) {
        this.setSize(this._label.width + left + right, this._label.height + top + bottom);
        this._label.anchor.set(0, 0);
        this._label.position.set(left, top);
    }

    public static createBackPlate():PIXI.NineSlicePlane {
        const backPlate = new PIXI.NineSlicePlane(SvgLoader.getSvgTexture(GuiDefaultTextures.PLATE_BASE_9), 9, 9, 9, 9);
        backPlate.tint = 0x000000;
        backPlate.alpha = 0.1;
        return backPlate;
    }

    public static createButtonStroke():PIXI.NineSlicePlane {
        const backPlate = new PIXI.NineSlicePlane(SvgLoader.getSvgTexture(GuiDefaultTextures.PLATE_STROKE_9), 9, 9, 9, 9);
        backPlate.tint = 0x000000;
        backPlate.alpha = 1.0;
        return backPlate;
    }

    public labelChange(value: string): void {
        this._label.text = NolimitApplication.apiPlugin.translations.translate(value);
        this.resizeButtonToLabelWithMargin(18, 30, 18, 30);
    }

    public borderTintChange(colorValue: number,styleNo:number): void {
        this._stroke.tint = colorValue;
        styleNo===1?this._label.setStyle(IntroButton.BUTTON_LABEL_STYLE):this._label.setStyle(this.BUTTON_LABEL_STYLE2);
    }
}